import { render, staticRenderFns } from "./OpenVPNClientForm.vue?vue&type=template&id=5565e86e&"
import script from "./OpenVPNClientForm.vue?vue&type=script&lang=js&"
export * from "./OpenVPNClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports